@let meta = afdModule()?.meta!;  

<kendo-card width="260px" (click)="onClick()" class="clickable" [class.selected]="selected()">
    <kendo-card-header class="header">
        <div class="header-row">
            <p>{{meta.name}}</p>
            <button kendoButton (click)="removeDialogOpen = true">Del</button>
            <button kendoButton (click)="onEdit()">Edit</button>
            <button kendoButton (click)="this.onCopy()" [svgIcon]="copyIcon"></button>
        </div>
    </kendo-card-header>
    <kendo-card-body>
        <validation-info [validation]="validation()" />
    </kendo-card-body>
</kendo-card>
<kendo-dialog *ngIf="removeDialogOpen" title="Remove Module" width="300px" (close)="removeDialogOpen = false">
    <p>Are you sure you want to delete {{meta.name}}?</p>
    <p><kendo-checkbox [(ngModel)]="removeIOs" #removeIOsLabel></kendo-checkbox><kendo-label text="Also remove I/Os" [for]="removeIOsLabel"></kendo-label></p>
    <kendo-dialog-actions>
        <button kendoButton (click)="removeDialogOpen = false">Cancel</button>
        <button kendoButton (click)="onRemove()" themeColor="primary">
            Remove
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
